exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-app{height:100vh;border:1px solid rgba(#000,.12)}#app{position:fixed;top:0;left:0;width:100%;height:100%}.no-shadow{box-shadow:none!important}.no-margin{margin:0!important}.md-card.md-with-hover{cursor:default}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fe8fa206","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 434
// module chunks = 0